var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4" },
        [
          !_setup.enrolledCampaign
            ? _c(
                "v-btn",
                {
                  staticClass: "soli-grey",
                  attrs: {
                    small: "",
                    rounded: "",
                    block: "",
                    elevation: "0",
                    activeClass: "primary--text",
                    disabled: _vm.disabled,
                  },
                  on: {
                    click: function ($event) {
                      _setup.newCampaign = true
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "", left: "" } }, [
                    _vm._v("add"),
                  ]),
                  _vm._v("New Automation"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.enrolledCampaign
            ? _c(
                "v-card",
                {
                  staticClass: "soli-round pa-4",
                  attrs: { flat: "", outlined: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-2" },
                    [
                      _c("div", { staticClass: "flex flex-col" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex justify-between items-center gap-2",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "soli-grey text-sm font-semibold",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _setup.enrolledCampaign.campaign.name
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                attrs: { left: "", "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    icon: "",
                                                    color: "dark",
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v("more_vert"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3646589340
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  _vm._l(
                                    _setup.campaignStatusOptions,
                                    function (status) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: status.text,
                                          attrs: {
                                            "input-value": status.value,
                                            disabled: _vm.disabled,
                                            color: "accent",
                                          },
                                          on: { click: status.action },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", small: "" } },
                                            [_vm._v(_vm._s(status.icon))]
                                          ),
                                          _vm._v(_vm._s(status.text)),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "soli-grey caption" }, [
                          _vm._v(
                            "\n                        Category: " +
                              _vm._s(
                                _setup.enrolledCampaign.campaign.category
                              ) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "soli-grey caption text-capitalize" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  `${
                                    _setup.enrolledCampaign.studentable
                                      .first_name
                                  } | ${
                                    _setup.enrolledCampaign.program?.title
                                  } | ${
                                    _setup.enrolledCampaign.instrument?.name ??
                                    "Not sure"
                                  }`
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _setup.enrolledCampaign.progress
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-between items-center gap-2",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "caption soli-grey" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _setup.enrolledCampaign.progress
                                              ?.name
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "capitalize",
                                      attrs: {
                                        color:
                                          _setup.enrolledCampaign.status.color,
                                        chip: "",
                                        "x-small": "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _setup.enrolledCampaign.status.value
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-progress-linear", {
                                attrs: {
                                  value: _setup.enrolledCampaign.progress?.stat,
                                  color: "secondary",
                                  height: "6",
                                  rounded: "",
                                },
                              }),
                              _vm._v(" "),
                              !["paused", "responsive", "waitlist"].includes(
                                _setup.enrolledCampaign.status.value
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "caption soli-grey" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _setup.enrolledCampaign
                                              .previous_campaign_message_id
                                              ? "Next Message: "
                                              : "First Message: "
                                          ) +
                                          "\n                        " +
                                          _vm._s(
                                            `${_vm
                                              .moment(
                                                _setup.enrolledCampaign
                                                  .next_send_date
                                              )
                                              .format("ddd, M/D")} at ${_vm
                                              .moment(
                                                _setup.enrolledCampaign
                                                  .next_send_date
                                              )
                                              .format("h:mma")}`
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.crmClient.past_campaigns.length
            ? _c(
                "v-simple-table",
                { staticClass: "soli-grey", attrs: { dense: "" } },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Past Automations")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Status")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.crmClient.past_campaigns,
                      function (campaignSubscription) {
                        return _c("tr", { key: campaignSubscription.id }, [
                          _c("td", [
                            _vm._v(_vm._s(campaignSubscription.campaign.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "capitalize",
                                  attrs: { chip: "", "x-small": "" },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        campaignSubscription.status.value
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _setup.newCampaign
        ? _c(_setup.CRMAutomationForm, {
            attrs: {
              crmClient: _vm.crmClient,
              relationships: _vm.relationships,
              errors: _vm.errors,
            },
            on: {
              reset: function ($event) {
                return _setup.reset()
              },
              success: function ($event) {
                return _setup.emit("toast", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.confirmResume
        ? _c("SoliChoice", {
            staticClass: "crm-z-more",
            attrs: {
              title: "Are you sure?",
              subtitle: `This will resume the ${_setup.enrolledCampaign?.campaign?.name} campaign for ${_vm.crmClient.first_name} and begin sending automated messages, starting now.`,
              button1: "Confirm",
              button2: "Nevermind",
              persistent: "",
              attach: ".z-more",
            },
            on: {
              option1: function ($event) {
                return _setup.resume()
              },
              option2: function ($event) {
                return _setup.reset(true)
              },
              reset: function ($event) {
                return _setup.reset()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.confirmStop
        ? _c("SoliChoice", {
            staticClass: "crm-z-more",
            attrs: {
              title: "Are you sure?",
              subtitle: `This will ${
                _setup.confirmStop == "paused" ? "pause" : "cancel"
              } ${_vm.crmClient.first_name}'s ${
                _setup.enrolledCampaign?.campaign?.name
              } and automated messages.`,
              button1: "Confirm",
              button2: "Nevermind",
              persistent: "",
              attach: ".z-more",
            },
            on: {
              option1: function ($event) {
                return _setup.stop(_setup.confirmStop)
              },
              option2: function ($event) {
                return _setup.reset(true)
              },
              reset: function ($event) {
                return _setup.reset()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }